import { useRecoilValue } from "recoil";
import { env } from "../../env/env";
import { DesignProduct } from "../../util/Products";
import { memberState } from "../../state/atoms";
import { isProSubscription } from "../../service/BillingService";

export interface DesignProductCardProps {
  product: DesignProduct;
}

export default function DesignProductCard({ product }: DesignProductCardProps) {
  const member = useRecoilValue(memberState);

  function onProductClick() {
    if (product.premium && !isProSubscription(member)) {
      window.location.href = env.dashboardPath + "/account/plan";
    } else {
      window.location.href = env.timberContextPath + "/design?size=" + product.key
    }
  }

  return (
    <li className={product.premium && !isProSubscription(member) ? 'gray-out' : ''}>
      <span onClick={() => onProductClick()}>
        <h6>{product.name}</h6>
        <img
          loading="lazy"
          src={product.img}
          alt={product.name}
        />
      </span>
      {product.premium && !isProSubscription(member) && 
      <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
    </li>
  );
}
